<script>
import { get } from "lodash";
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { VodafoneLab } from "../../modules/vodafone_lab_module.js";

export default {
  mixins: [fandomBasicMixin],
  data() {
    return {
      selectedTarget: "",
      selectedIndustry: "",
      loading: false,
      success: false,
      errors: []
    }
  },
  mounted() {
    this.selectedTarget = get(globalState.pageModel, ["user","target", 0], "");
    this.selectedIndustry = get(globalState.pageModel, ["user","industry", 0], "");
  },
  methods: {
    fireLinkEvent(label) {
      if (!!window.wa_gc) {
        const digitalData = Fandom.deepClone(window.digitalData);
        digitalData.link_name = `${VodafoneLab.getPageName()}${label}`;
        window.wa_gc(digitalData, "link");
        console.log("%cExecuted wa_gc(digitalData, 'link')", "background: #222; color: #bada55; padding: .5rem;", digitalData);
      }
    },
    updateUserPreferences() {
      if ((this.selectedTarget != "" && this.selectedIndustry != "") || true) {
        this.loading = true;
        Fandom.ajax({
          url: "/api/v5/user/preferences",
          method: "PUT",
          data : {
            target: this.selectedTarget,
            industry: this.selectedIndustry
          },
          success: (data) => {
            this.loading = false;
            this.success = data.success;
            Vue.set(this, "errors", []);
          },
          error: (err) => {
            this.loading = false;
            this.success = false;
            this.errors = err.responseJSON.errors;
          }
        })
      } else {
        this.errors = ["Per favore seleziona un target e un'industria per aggiornare le tue preferenze."];
      }
    }
  },
  computed: {
    theme() {
      const themeName = get(this, ["content", "theme"], "light");
      return `${themeName}-theme bg-${themeName} navbar-${themeName}`;
    },
    componentStyle() {
      return {
        "background-color": this.content.background_color
      };
    },
    industries() {
      return Object.keys(this.pageModel.name_to_content).filter(key => {
        return key.startsWith("industry-") && this.pageModel.name_to_content[key].parent_names.includes(this.selectedTarget)
      });
    },
  }
};
</script>

<template>
  <div class="w-100" :class="theme" user-edit-component :style="componentStyle">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-8 col-lg-6 my-5">
          <div class="pb-4 mb-4 border-bottom border-dark">
            <h4 class="mb-5 user-edit-title font-weight-normal">{{ft("globals.user_profile.user_edit_title")}}</h4>
            <generic-form @done="fireLinkEvent(':Profile save')" :content="content" :opt-container-content="containerContent" class="mb-5"></generic-form>
          </div>
          <div class="pb-5 mb-4 border-bottom border-dark">
            <h4 class="mb-5 user-edit-title font-weight-normal">{{ft("globals.user_profile.user_preferences_title")}}</h4>
            <div class="form-group text-left">
              <label for="target">A quale tipologia appartiene la tua azienda?</label>
              <select required v-model="selectedTarget" class="form-control">
                <option value="" selected>Seleziona una voce</option>
                <option v-for="(target) in getContent('target').children" :key="target" :value="target">{{getContent(target).title}}</option>
              </select>
            </div>
            <div class="form-group text-left">
              <label for="target">A quale settore appartiene la tua azienda?</label>
              <select required v-model="selectedIndustry" class="form-control">
                <option value="" selected>Seleziona una voce</option>
                <option v-for="(industry) in industries" :key="industry" :value="industry">{{getContent(industry).title}}</option>
              </select>
            </div>
            <button type="submit" class="btn btn-primary" @click="updateUserPreferences" :class="{'disabled': loading}" :disabled="loading">
              Aggiorna
            </button>
            <form-feedback class="mt-4" :success-message="ft('globals.user_profile.preferences_updated_correctly')" :success="success" :errors="errors"></form-feedback>
          </div>
          <h4 class="mb-5 user-edit-title font-weight-normal">{{ft("globals.user_profile.password_edit_title")}}</h4>
          <user-password-editing-form @done="fireLinkEvent(':Password save')" :content="content" :opt-container-content="containerContent"></user-password-editing-form>
        </div>  
      </div>
    </div>
  </div>
</template>

<style lang="scss">
</style>
